/**
 * @generated SignedSource<<bccf5c3b1cc122f6fb34b36785973000>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type eventBaseInlineFragment$data = {
  readonly id: string;
  readonly name: string;
  readonly accountId: string;
  readonly userId: string;
  readonly beginsAt: any;
  readonly endsAt: any;
  readonly timeZone: string;
  readonly status: string;
  readonly icalendar: string | null;
  readonly recurrenceID: string | null;
  readonly " $fragmentType": "eventBaseInlineFragment";
};
export type eventBaseInlineFragment$key = {
  readonly " $data"?: eventBaseInlineFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"eventBaseInlineFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "eventBaseInlineFragment"
};

(node as any).hash = "2ddb5a0214ad9e724e76800abe4571eb";

export default node;
